<template>
    <div class="main-container-l">
        <OutrightsMenu
        v-if="isMobile && gamesMenuShown && outrightsTreeMapping != null"
        @toggleGamesMenu="toggleGamesMenu"
        :pagetype="'outrightsOffer'"/>
        <OfferCalendar
        v-if="isMobile && !gamesMenuShown"
        @togglegamesmenu="toggleGamesMenu"
        show-back-button />

        <div class="offer-container-l">
            <OutrightsMenu
            v-if="!isMobile && outrightsTreeMapping != null"
            :pagetype="'outrightsOffer'"/>
            <div class="group-offer-l">
                <OfferCalendar
                v-if="!isMobile"
                show-back-button />
                <OutrightsTabs
                v-if="selectedOutrightIds.length > 0
                && smallDesktop && !isMobile"
                :filterSelected="filterSelected" />
                 <template v-for="outright of getOutrights">
                    <OutrightsSingle
                    v-if="(smallDesktop || isMobile) && selectedOutrightId"
                    :outright="outright"
                    :key="outright.outrightsOfferId"/>
                </template>

                <div v-if="outrightError" class="group-game empty">
                    <div class="error-offer-loading">
                        <img class="odd-stats-img" src="../../assets/img/error-offer-loading.svg" alt="">
                        <p>{{$t('OFFERLOADINGERROR')}}</p>
                    </div>
                </div>
                <div v-else-if="filteredOutrights.length" class="group-game" >
                    <DynamicScroller
                    :buffer="lastTopScroll !== null ? lastTopScroll : 200"
                    :items="filteredOutrights"
                    :min-item-size="50"
                    key-field="itemId"
                    class="tournaments-scroller"
                    ref_testcafe="tournamentContainer">
                        <template v-slot="{ item, index, active }">
                            <DynamicScrollerItem :item="item" :active="active" :data-index="index" :ref_testcafe="`dataIndex${[index]}`">
                                <OutrightTournaments
                                :key="item.itemId"
                                :singleOutrightTournament="item"
                                type ='outrights' />
                            </DynamicScrollerItem>
                        </template>
                    </DynamicScroller>
                </div>
            </div>

            <div v-if="!smallDesktop && !isMobile && selectedOutrightId != null" class="single-offer-l">
                <div class="single-games-box">
                    <OutrightsTabs
                    :filterSelected="filterSelected" />
                    <OutrightsSingle
                    v-for="outright of getOutrights"
                    :outright="outright"
                    :key="outright.outrightsOfferId" />
               </div>
            </div>
        </div>
        <Betslip v-if="betslip" />
    </div>
</template>

<script>
import {
    mapActions,
    mapGetters,
} from 'vuex';
// eslint-disable-next-line no-unused-vars
import moment from 'moment-timezone';
import Betslip from '../components/betslip/Betslip.vue';
import OfferCalendar from '../components/OfferCalendar.vue';
import OutrightsMenu from './containers/OutrightsMenu.vue';
import OutrightTournaments from './containers/OutrightsTournaments.vue';
import OutrightsTabs from './containers/OutrightsTabs.vue';
import OutrightsSingle from './containers/OutrightsSingle.vue';

export default {
    name: 'Outrights',
    components:
    {
        Betslip,
        OfferCalendar,
        OutrightsMenu,
        OutrightTournaments,
        OutrightsTabs,
        OutrightsSingle,
    },
    data()
    {
        return {
            specialDates: ['+3h', '+6h', '+12h', 'all'],
            gamesMenuShown: true,
            filterSelected: null,
            lastTopScroll: null,
            shouldReverse: false,
            isFirstRender: true,
        };
    },
    async created()
    {
        const me = this;

        if (me.isMobile
        || (!me.isMobile && me.smallDesktop))
        {
            window.scroll({
                top: 0,
            });
        }

        await me.normalizeDateTimeParams();
        await me.fetchOutrightOffer();

        if (this.betslipType !== 'sport')
        {
            me.toggleBetslipDef('simple');
        }

        me.clearOtherItems([
            'sport',
            'outrights',
        ]);

        me.loadBetslipStorageItems({
            type: 'sport',
            skipFetch: this.betslipType === 'sport',
        });
    },
    methods: {
        ...mapActions({
            selectSpecialDate: 'selectSpecialDate',
            selectEvent: 'selectEvent',
            initOutrightsOffer: 'initOutrightsOffer',
            setOutrightsOfferLoading: 'setOutrightsOfferLoading',
            destroyOutrightOffer: 'destroyOutrightOffer',
            makeTree: 'makeTree',
            setSelectedOutrightsItems: 'setSelectedOutrightsItems',
            setFilteredOutrights: 'setFilteredOutrights',
            removeOutright: 'removeOutright',
            selectOutright: 'selectOutright',
            clearOtherItems: 'clearOtherItems',
            toggleBetslipDef: 'toggleBetslipDef',
            loadBetslipStorageItems: 'loadBetslipStorageItems',
        }),
        validStartDateParam()
        {
            const me = this;
            const { startDate } = me.$route.params;
            if (me.specialDates.includes(startDate) || moment(startDate, 'YYYY-MM-DD', true).isValid())
            {
                return true;
            }
            return false;
        },
        async normalizeDateTimeParams()
        {
            const me = this;

            const params = {
                startDate: moment.utc(),
            };

            if (!me.$route.params.startDate)
            {
                me.$router.push({
                    params:
                {
                    startDate: moment.utc(params.startDate).local().format('YYYY-MM-DD'),
                },
                });
                return;
            }

            if (me.validStartDateParam())
            {
                me.selectSpecialDate({
                    date: moment.utc(params.startDate).local().format('YYYY-MM-DD'),
                    setSpecialDate: true,
                });
            }
            else
            {
                me.$router.push({
                    params:
                {
                    startDate: moment.utc(params.startDate).local().format('YYYY-MM-DD'),
                    pathMatch: `${me.$route.params.startDate}/${me.$route.params.pathMatch}`,
                },
                });
            }
        },
        toggleGamesMenu()
        {
            const me = this;
            me.gamesMenuShown = !me.gamesMenuShown;
        },
        async fetchOutrightOffer()
        {
            const me = this;
            await me.initOutrightsOffer('outrights');

            await me.makeTree();
        },
    },
    computed: {
        ...mapGetters([
            'globals',
            'offerHandling',
            'isMobile',
            'startDate',
            'endDate',
            'specialDate',
            'smallDesktop',
            'getOutrights',
            'outrightError',
            'selectedOutrightId',
            'selectedOutrightIds',
            'outrightsTreeMapping',
            'allTreeItems',
            'selectedOutrightsItems',
            'filteredOutrights',
            'betslip',
            'betslipType',
        ]),
    },
    watch: {
        selectedOutrightId(outrightId)
        {
            const me = this;

            if (outrightId == null)
            {
                me.$nextTick(() =>
                {
                    window.scroll({
                        top: me.lastTopScroll,
                    });
                    me.lastTopScroll = null;
                });
            }
            else
            {
                me.lastTopScroll = window.pageYOffset;
            }
        },
        '$route.params.startDate'(val)
        {
            const me = this;

            if (val !== undefined)
            {
                me.selectSpecialDate({
                    date: val,
                    setSpecialDate: true,
                });
            }
            if (val !== me.$route.params.startDate)
            {
                me.fetchOutrightOffer();
            }
        },
        '$route.params.pathMatch'(val)
        {
            const me = this;
            me.filterSelected = '';
            let selectedOutrightItems = [];

            if (val === undefined)
            {
                me.setSelectedOutrightsItems(selectedOutrightItems);
                return;
            }

            const routes = me.$route.params.pathMatch.split(',');

            for (const route of routes)
            {
                for (const treeItem of me.allTreeItems)
                {
                    if (treeItem.id === Number(route))
                    {
                        if (me.filterSelected === '')
                        {
                            me.filterSelected += `${treeItem.name}`;
                        }
                        else
                        {
                            me.filterSelected += ` - ${treeItem.name}`;
                        }
                        break;
                    }
                }
            }
            if (val != null)
            {
                selectedOutrightItems = me.$route.params.pathMatch.split(',');
            }
            me.setSelectedOutrightsItems(selectedOutrightItems);
        },
        selectedOutrightsItems()
        {
            const me = this;
            me.setFilteredOutrights(me.getOutrights);
        },
    },
    beforeDestroy()
    {
        const me = this;
        me.destroyOutrightOffer();
    },
};
</script>

<style>

</style>
